import { Container as MContainer } from '@mui/material';
import React from 'react';

type Props = {
  children: React.ReactNode;
  id?: string;
  styles?: React.CSSProperties;
};

function UiContainer({ styles, ...rest }: Props) {
  return <MContainer maxWidth="xl" sx={styles} {...rest} />;
}

export default UiContainer;
